import { Arrange } from "@aviary";
import { SvgCarbonZeroLogo, SvgHipaaLogo } from "@shared/assets/images";
import { useSharedGlobalConfig } from "@shared/hooks";

import * as styles from "./FooterLogos.styles";

const FooterLogos = () => {
  const { isUS, isEmerson } = useSharedGlobalConfig();

  return (
    <Arrange isWrapped={false} spacing="none" justify="center">
      {!isEmerson && <SvgCarbonZeroLogo />}
      {isUS && !isEmerson && <SvgHipaaLogo css={styles.spacingLeft} />}
    </Arrange>
  );
};

export { FooterLogos };
